import { FormatConstants } from 'services/keyConstants';

export const internalCircularOptions = [
  { value: "allUsers", label: "All Users" },
  { value: "department", label: "Department" },
  { value: "selectUsers", label: "Select Users" },
];

export const getStatusTypes = (type) => {
  switch (type) {
    case FormatConstants.INTERNAL_COMMUNICATION.INTERNAL_CIRCULAR:
      return {
        filteredData: {
          page: 1,
          totalPage: 1,
          status: "Initiated"
        },
        defaultOptionData: {
          statusOptions: [
            { label: "Initiated", value: "Initiated" },
            { label: "Received", value: "Received" },
          ]
        }
      };
      break;

    // Default case if no matching type is found
    default:
      return {
        filteredData: {
          status: "Unknown",
          documentName: "Unknown Document",
        },
        defaultOptionData: {
          statusOptions: []
        }
      };
  }
};
